import { useMemo } from "react";
import { UserType } from "@src/types.generated";
import {
  RoleDialogBody_RoleFragment,
  useRoleDialogBody_RolesQuery,
} from "@src/features/roles/dialogs/RoleDialogBody.generated";

type UseAvailableRoleLevels = {
  roles: RoleDialogBody_RoleFragment[];
  loading: boolean;
  managerRoleLevels: number[];
  maxRoleLevel: number;
  availableRoleLevels: number[];
};

const useAvailableRoleLevels = (): UseAvailableRoleLevels => {
  const { data, loading } = useRoleDialogBody_RolesQuery();

  const roles = useMemo(() => {
    return data?.Roles?.objects || [];
  }, [data]);

  const managerRoleLevels = useMemo(() => {
    return roles
      .filter((r) => r.roleActionPermissions?.roleUserType === UserType.Manager)
      .map((r) => r.roleLevelV2)
      .filter((level): level is number => level != null);
  }, [roles]);

  const maxRoleLevel = useMemo(() => {
    return managerRoleLevels.length > 0 ? Math.max(...managerRoleLevels, 1) : 1;
  }, [managerRoleLevels]);

  const availableRoleLevels = useMemo(() => {
    return Array.from({ length: maxRoleLevel }, (_, i) => i + 1);
  }, [maxRoleLevel]);

  return {
    roles,
    loading,
    managerRoleLevels,
    maxRoleLevel,
    availableRoleLevels,
  };
};

export default useAvailableRoleLevels;
